import {h, Fragment} from "preact"
import { useProductFilters } from "@nosto/preact"
import Icon from "./elements/Icon";

function FilterRemoveButton({ filter, className }) {
    return (
        <button
            className={`ns-act-btn ns-text-align-right ns-align-items-center ns-clickable ns-p-1 ns-mr-1 ns-color-black ${className}`}
            onClick={() => filter.remove()}
        >
            <Icon
                name="close-bold"
                className="pd-icon-filters"
            />
        </button>
    )
}

export default function SelectedFiltersCustom() {
    const { filters, removeAll } = useProductFilters()

    return (
        filters.length > 0 && (
                <div class={`ns-pt-2 ns-pb-2 pd-sidebar__selected-desktop`}>
                <div
                    class="ns-d-inline-block ns-relative ns-w-100 ns-border-box ns-text-undecorated ns-pt-4 ns-mb-4 ns-pb-2 pd-filters-title"
                >
                    <span class="ns-color-black ns-font-5 pd-text-uppercase">Current Filters</span>
                </div>
                <div class="ns-col-10 ns-d-flex ns-flex-wrap ns-align-items-center">
                    {filters.map(filter => (
                        <div class="pd-selected-filter ns-d-flex ns-align-items-center ns-px-2 ns-mr-1 ns-mb-1 ns-font-4" onClick={() => filter.remove()}>
                            <FilterRemoveButton filter={filter} />
                            <span class="ns-color-black">
                                {filter.name}: {filter.value}
                            </span>
                        </div>
                    ))}
                </div>
                <div class="ns-col-10 ns-d-flex ns-flex-wrap ns-align-items-center">

                    <div onClick={() => {
                        removeAll()
                    }} class="pd-selected-filter ns-d-flex ns-align-items-center ns-px-2 ns-mr-1 ns-mb-1 ns-font-4">
                        <FilterRemoveButton />
                        <span class="ns-color-black">
                            Clear All
                        </span>
                    </div>
                </div>

            </div>
        )
    )
}
